// extracted by mini-css-extract-plugin
export default {"goodWrap":"goodWrap___wtcLu","right":"right___s71kf","contentWrap":"contentWrap___KBu0d","content":"content___dkfTJ"};